/**
 * Réponses confort / accessibilité (onboarding IA LILATE et FlashLevel).
 * Persistées sur Lilate / Elate via ai_comfort_chips et ai_comfort_details.
 */

export interface ComfortChipOption {
    id: string;
    icon: string;
    labelKey: string;
}

export interface ComfortAnswers {
    chips: string[];
    details: string | null;
}

export const COMFORT_CHIP_OPTIONS: ComfortChipOption[] = [
    { id: 'writing', icon: '✍️', labelKey: 'ai-exam-onboarding.comfort.chip.writing' },
    { id: 'speaking', icon: '🎙️', labelKey: 'ai-exam-onboarding.comfort.chip.speaking' },
    { id: 'time', icon: '⏱️', labelKey: 'ai-exam-onboarding.comfort.chip.time' },
    { id: 'stress', icon: '😰', labelKey: 'ai-exam-onboarding.comfort.chip.stress' },
    { id: 'reading', icon: '👁️', labelKey: 'ai-exam-onboarding.comfort.chip.reading' },
    { id: 'hearing', icon: '👂', labelKey: 'ai-exam-onboarding.comfort.chip.hearing' },
    { id: 'dys', icon: '🧠', labelKey: 'ai-exam-onboarding.comfort.chip.dys' },
];

const VALID_COMFORT_CHIP_IDS = new Set(COMFORT_CHIP_OPTIONS.map((chip) => chip.id));

export function emptyComfortAnswers(): ComfortAnswers {
    return { chips: [], details: null };
}

/**
 * Construit le payload PATCH Lilate/Elate pour l'étape confort.
 * Retourne null si aucune donnée à enregistrer (skip ou formulaire vide).
 */
export function buildComfortPatchPayload(
    answers: ComfortAnswers | null
): { ai_comfort_chips: string[]; ai_comfort_details: string | null } | null {
    if (!answers) {
        return null;
    }
    const chips = (answers.chips || []).filter((id) => VALID_COMFORT_CHIP_IDS.has(id));
    const details = (answers.details || '').trim() || null;
    if (chips.length === 0 && !details) {
        return null;
    }
    return {
        ai_comfort_chips: chips,
        ai_comfort_details: details,
    };
}
